module.exports = __webpack_public_path__ + "assets/lessons/hr/lesson2/pages/lesson_2_04.pdf";